export default {"src":"/_next/static/media/BHD.6ee4ec61.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};